"use strict";

const Decimal = require("decimal.js");

const ledgerSoldForContract = (tonsSoldByContract, contractId) => {
  if (tonsSoldByContract == null) { return new Decimal(0); }
  return new Decimal(
    tonsSoldByContract[contractId] ??
    tonsSoldByContract[String(contractId)] ??
    0
  );
};

const getContractRemainingInPool = (
  contract,
  poolId,
  tonsSoldByContract
) => {
  const allocs = contract.Allocations || [];
  const alloc = allocs.find(
    (a) => String(a.inventoryPoolId) === String(poolId)
  );
  if (!alloc) { return new Decimal(0); }
  const allocated = new Decimal(alloc.tonsAllocated || 0);

  if (tonsSoldByContract != null) {
    const sold = ledgerSoldForContract(tonsSoldByContract, contract.id);
    const remaining = allocated.minus(sold);
    return remaining.gt(0) ? remaining : new Decimal(0);
  }

  const totalAllocated = allocs.reduce(
    (s, a) => s.plus(new Decimal(a.tonsAllocated || 0)),
    new Decimal(0)
  );
  const share = totalAllocated.gt(0)
    ? allocated.div(totalAllocated)
    : new Decimal(0);
  const sold = share.times(new Decimal(contract.tonsSold || 0));
  return allocated.minus(sold);
};

const compareDrawdownContracts = (a, b) => {
  const orderA = a.projectDrawDownOrder ?? 0;
  const orderB = b.projectDrawDownOrder ?? 0;
  if (orderA !== orderB) {
    return orderA - orderB;
  }
  return a.id - b.id;
};

const getContractsForProjectInPool = (contractsPlain, projectId, poolId) => {
  return contractsPlain
    .filter(
      (c) =>
        c.voidedOn == null &&
        String(c.projectId) === String(projectId) &&
        (c.Allocations || []).some(
          (a) => String(a.inventoryPoolId) === String(poolId)
        )
    )
    .slice()
    .sort(compareDrawdownContracts);
};

const getActiveDrawdownContract = (
  contractsPlain,
  projectId,
  poolId,
  tonsSoldByContract
) => {
  const matching = getContractsForProjectInPool(
    contractsPlain,
    projectId,
    poolId
  );
  if (!matching.length) { return null; }

  const withRemaining = matching.filter((c) =>
    getContractRemainingInPool(c, poolId, tonsSoldByContract).gt(0)
  );
  const candidates = withRemaining.length ? withRemaining : matching;
  return candidates[0];
};

const getRemainingTons = (
  contractsPlain,
  projectId,
  poolId,
  tonsSoldByContract
) => {
  const matching = getContractsForProjectInPool(
    contractsPlain,
    projectId,
    poolId
  );
  if (!matching.length) { return new Decimal(0); }

  return matching.reduce(
    (sum, c) =>
      sum.plus(getContractRemainingInPool(c, poolId, tonsSoldByContract)),
    new Decimal(0)
  );
};

module.exports = {
  ledgerSoldForContract,
  getContractRemainingInPool,
  compareDrawdownContracts,
  getContractsForProjectInPool,
  getActiveDrawdownContract,
  getRemainingTons
};
